import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useState } from 'react';
import { ServiceTypesState } from 'shared/models/ServiceTypes';
import { SortState } from 'shared/models/tabletReactQuery';
import { serviceTypesService } from 'shared/services/shared/serviceTypesService';


export const getDefaultSort = (): SortState => ({
  sortDir: 'ASC',
  sortBy: 'name'
});

export const getDefaultState = (): ServiceTypesState => ({
  page: 1,
  rowsPerPage: 20,
  sort: getDefaultSort(),
  filters: {},
  columnVisibility: {}
});

export const useServiceTypes = () => {
  const ServiceTypesService = serviceTypesService();
  const [state, setState] = useState<ServiceTypesState>(getDefaultState());
  const getServiceTypes = useSuperQuery(
    () =>
      ServiceTypesService.getAll(
        state.page,
        state.rowsPerPage,
        state.sort.sortBy,
        state.sort.sortDir,
      ),
    {
      showSpinner: true
    },
    [state.page, state.rowsPerPage, state.sort.sortBy, state.sort.sortDir]
  );    


  return {
    serviceTypes: {
      data: getServiceTypes.data?.rows || [],
      total: getServiceTypes.data?.total || 0,
      isLoading: getServiceTypes.isLoading,
      error: getServiceTypes.error,
      reload: getServiceTypes.reload,
      serverSideOptions: {
        page: state.page - 1,
        count: getServiceTypes.data?.total || 0,
        rowsPerPage: state.rowsPerPage,
        sortOrder: {
          name: state.sort.sortBy,
          direction: state.sort.sortDir.toLowerCase() as 'asc' | 'desc'
        }
      }
    }
  };
};
